module.exports = __webpack_public_path__ + "static/home_scopri3-5bd616fdf934b07c54513fa9c6cc60f7.jpg";